import type { GraphqlConnectionNode, GraphqlPageInfo } from '@ctw/shared/api/fqs/client';
import { fragmentProcedure, fragmentReference } from '@ctw/shared/api/fqs/queries/fragments';
import type { Procedure, Provenance } from 'fhir/r4';
import { gql } from 'graphql-request';

export type ProcedureWithProvenance = Procedure & {
  ProvenanceList: Array<Provenance>;
};

export interface ProcedureConnection {
  pageInfo: GraphqlPageInfo;
  edges: Array<GraphqlConnectionNode<ProcedureWithProvenance>>;
}

export interface ProcedureGraphqlResponse {
  ProcedureConnection: ProcedureConnection;
}

export const procedureQuery = gql`
  ${fragmentReference}
  ${fragmentProcedure}

  query Procedures(
    $upid: ID!
    $cursor: String!
    $sort: ProcedureSortParams!
    $filter: ProcedureFilterParams!
    $first: Int!
  ) {
    ProcedureConnection(
      upid: $upid
      after: $cursor
      filter: $filter
      sort: $sort
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Procedure
        }
      }
    }
  }
`;
